import { render, staticRenderFns } from "./AdministracionPage.vue?vue&type=template&id=51520f55&scoped=true"
import script from "./AdministracionPage.vue?vue&type=script&lang=ts"
export * from "./AdministracionPage.vue?vue&type=script&lang=ts"
import style0 from "./AdministracionPage.vue?vue&type=style&index=0&id=51520f55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51520f55",
  null
  
)

export default component.exports